import { ifElse, always, prop, compose } from 'ramda';

import { isDirectToPay } from 'app/features/user/selectors';

const landing = prop('landing');

const isNewExperience = compose(prop('isNewExperience'), landing);

const landingPageName = ifElse(
  isDirectToPay,
  always('Direct to Pay Landing Page'),
  always('Welcome Free Trial Landing Page'),
);

export { landing, landingPageName, isNewExperience };
